/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { schema3OtherRefreshRepositoriesApiV1SandboxGithubRepositoriesRefreshPost } from "../../funcs/schema3OtherRefreshRepositoriesApiV1SandboxGithubRepositoriesRefreshPost.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .RefreshRepositoriesApiV1SandboxGithubRepositoriesRefreshPostRequest$inboundSchema,
};

export const tool$schema3OtherRefreshRepositoriesApiV1SandboxGithubRepositoriesRefreshPost:
  ToolDefinition<typeof args> = {
    name:
      "schema-3-other-refresh-repositories-api-v1-sandbox-github-repositories-refresh-post",
    description: `Refresh Repositories`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await schema3OtherRefreshRepositoriesApiV1SandboxGithubRepositoriesRefreshPost(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
